import { render } from "./Usermenu.vue?vue&type=template&id=62c7b622&scoped=true"
import script from "./Usermenu.vue?vue&type=script&lang=js"
export * from "./Usermenu.vue?vue&type=script&lang=js"

import "./Usermenu.vue?vue&type=style&index=0&id=62c7b622&scoped=true&lang=css"

import exportComponent from "C:\\CEDIS\\cedispage2.0_general_guvi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62c7b622"]])

export default __exports__